module.exports = __webpack_public_path__ + "static/000_body-landscape-383f138540425b8b0e6d942d54d2ce64.mp4";